import { Helmet } from 'components/helmet';

const baseGlobalStyles = /*css*/ `
  /**
   * Styles to disable bound scrolling on iOS
   * https://stackoverflow.com/a/42055497
   */
  html {
    overflow: hidden;
  }
  /**
  * need to override Pypestream styles
  */
  #pypestream-wrapper{
    display: contents !important;
    height: 100%;
    width: 100%;
  }
`;

export const GlobalStylesheet = () => (
  <Helmet>
    <style>{baseGlobalStyles}</style>
  </Helmet>
);
